import {createUseQuery, createUseMutation, createUseLazyQuery} from "@irati/utils/services/apollo"

import getSignUpQuery, {getSignUpKey} from "./services/queries/signUp"
import listCompaniesQuery, {listCompaniesKey} from "./services/queries/listCompanies"
import getQuoteQuery, {getQuoteKey} from "./services/queries/quote"
import getPaymentLink, {getPaymentLinkKey} from "./services/queries/getPaymentLink"
import getTermsAndConditions, {getTermsAndConditionsKey} from "./services/queries/getTermsAndConditions"

import confirmSignUpPayment, {confirmSignUpPaymentKey} from "./services/mutations/confirmSignUpPayment"
import startSignUpMutation, {startSignUpKey} from "./services/mutations/startSignUp"
import addCompanyMutation, {addCompanyKey} from "./services/mutations/addCompany"
import addIndividual, {addIndividualKey} from "./services/mutations/addIndividual"
import updateEnquiry, {updateEnquiryKey} from "./services/mutations/updateEnquiry"
import acceptTermsAndConditions, {acceptTermsAndConditionsKey} from "./services/mutations/acceptTermsAndConditions"
import ignoreIndividualCheck, {ignoreIndividualCheckKey} from "./services/mutations/ignoreIndividualCheck"

export const useGetSignUpQuery = createUseQuery(getSignUpQuery, {key: getSignUpKey})
export const useListCompanies = createUseLazyQuery(listCompaniesQuery, {key: listCompaniesKey})
export const useGetQuoteQuery = createUseQuery(getQuoteQuery, {key: getQuoteKey})
export const useGetPaymentLink = createUseQuery(getPaymentLink, {key: getPaymentLinkKey})
export const useGetTermsAndConditions = createUseQuery(getTermsAndConditions, {key: getTermsAndConditionsKey})

export const useStartSignUp = createUseMutation(startSignUpMutation, {key: startSignUpKey})
export const useAddCompany = createUseMutation(addCompanyMutation, {key: addCompanyKey})
export const useAddIndividual = createUseMutation(addIndividual, {key: addIndividualKey})
export const useUpdateEnquiry = createUseMutation(updateEnquiry, {key: updateEnquiryKey})
export const useAcceptTermsAndConditions = createUseMutation(acceptTermsAndConditions, {key: acceptTermsAndConditionsKey})
export const useConfirmSignUpPayment = createUseMutation(confirmSignUpPayment, {key: confirmSignUpPaymentKey})
export const useIgnoreIndividualCheck = createUseMutation(ignoreIndividualCheck, {key: ignoreIndividualCheckKey})
